module.exports = __webpack_public_path__ + "media/images/icons/vendors/first_dance-62a4e8ca241df2f1f69e15b229c19b94.png";